import React, { useRef } from 'react';
import FullscreenWindow from '../FullscreenWindow';
import { useStreamingFeature } from './hooks/useStreamingFeature';

/**
 * DisplayModeFullscreen - Wraps streamed feature in full-screen window
 * Used for mobile viewports (<1024px)
 */
export function DisplayModeFullscreen({
  bundleUrl,
  title,
  onClose,
  ...windowProps
}) {
  const containerRef = useRef(null);
  const { loading, error, mounted } = useStreamingFeature(bundleUrl, containerRef);

  return (
    <FullscreenWindow
      title={title}
      onClose={onClose}
      {...windowProps}
    >
      <div 
        ref={containerRef}
        style={{ width: '100%', height: '100%' }}
        className="streaming-feature-container"
      >
        {loading && (
          <div className="flex items-center justify-center h-full bg-slate-900">
            <div className="text-white">Loading feature...</div>
          </div>
        )}
        {error && (
          <div className="flex items-center justify-center h-full bg-slate-900 p-4">
            <div className="text-red-400 text-center">
              <div className="font-semibold mb-2">Error loading feature</div>
              <div className="text-sm">{error}</div>
            </div>
          </div>
        )}
      </div>
    </FullscreenWindow>
  );
}

